module.exports = __webpack_public_path__ + "static/media/promo4.0e2bf6a8.jpg";